import { Action } from 'redux';
import { CancelTokenSource } from 'axios';

import { UPLOAD_CANCEL, UPLOAD_DONE, UPLOAD_SET_CANCEL_TOKEN_SOURCE } from './types';

export type UploadSetCancelTokenSourceAction = {
    readonly type: typeof UPLOAD_SET_CANCEL_TOKEN_SOURCE;
    readonly payload: CancelTokenSource;
};

export type UploadCancelAction = Action<typeof UPLOAD_CANCEL>;

export type UploadDoneAction = Action<typeof UPLOAD_DONE>;

export type UploadAction = UploadSetCancelTokenSourceAction | UploadCancelAction | UploadDoneAction;

export function setCancelTokenSource(cancelTokenSource: CancelTokenSource): UploadSetCancelTokenSourceAction {
    return {
        type: UPLOAD_SET_CANCEL_TOKEN_SOURCE,
        payload: cancelTokenSource
    };
}

export function cancelUpload(): UploadCancelAction {
    return { type: UPLOAD_CANCEL };
}

export function uploadDone(): UploadDoneAction {
    return { type: UPLOAD_DONE };
}
